export const transactionTableHeaders = {
  inward: [
    {
      id: 'serial_number',
      name: 'S.No.',
      align: 'center',
      disable: true,
      sx: { minWidth: '64px !important', width: '64px !important', px: 0.75 }
    },
    { id: 'id', name: 'Order ID', align: 'center' },
    { id: 'order_date', name: 'Order Date', align: 'center' },
    { id: 'delivery_date', name: 'Delivery Date', align: 'center' },
    { id: 'site_name', name: 'Site Name', align: 'center' },
    { id: 'invoice_number', name: 'Invoice Number', align: 'center' },
    { id: 'quantity', name: 'Fuel Quantity', align: 'center' },
    { id: 'price_per_litre', name: 'Unit Price', align: 'center' },
    { id: 'supplier', name: 'Supplier', align: 'center' },
    { id: 'source', name: 'Source', align: 'center' },
    { id: 'received_tank_name', name: 'Received Tank', align: 'center' },
    {
      id: 'action', disable: true, name: 'Action', align: 'center'
    }
  ],
  iot: [
    {
      id: 'serial_number',
      name: 'S.No.',
      align: 'center',
      disable: true,
      sx: { minWidth: '64px !important', width: '64px !important', px: 0.75 }
    },
    { id: 'order_id', name: 'Order ID', align: 'center' },
    { id: 'vehicle_number', name: 'Vehicle Number', align: 'center' },
    { id: 'quantity', name: 'Fuel Quantity', align: 'center' },
    { id: 'address', name: 'Dispenser Address', align: 'center' },
    { id: 'site_name', name: 'Site Name', align: 'center' },
    { id: 'opening_stock', name: 'Opening Stock', align: 'center' },
    { id: 'closing_stock', name: 'Closing Stock', align: 'center' },
    { id: 'end_time', name: 'Delivery Time', align: 'center' },
    { id: 'nozzle_num', name: 'Nozzle Number', align: 'center' },
    { id: 'vehicle_model', name: 'Vehicle Model', align: 'center' },
    { id: 'vehicle_category', name: 'Vehicle Category', align: 'center' },
    { id: 'odometer_entry', name: 'Odometer Reading', align: 'center' },
    {
      id: 'action', disable: true, name: 'Action', align: 'center'
    }
  ],
  transfer: [
    {
      id: 'serial_number',
      name: 'S.No.',
      align: 'center',
      disable: true,
      sx: { minWidth: '64px !important', width: '64px !important', px: 0.75 }
    },
    { id: 'order_id', name: 'Order ID', align: 'center' },
    { id: 'vehicle_number', name: 'Vehicle Number', align: 'center' },
    { id: 'card_num_1', name: 'Vehicle Card', align: 'center' },
    { id: 'site_name', name: 'Site Name', align: 'center' },
    { id: 'end_time', name: 'Delivery Time', align: 'center' },
    { id: 'address', name: 'Dispenser Address', align: 'center' },
    { id: 'nozzle_num', name: 'Nozzle Number', align: 'center' },
    { id: 'card_num_2', name: 'Operator Card', align: 'center' },
    { id: 'vehicle_model', name: 'Vehicle Model', align: 'center' },
    { id: 'vehicle_category', name: 'Vehicle Category', align: 'center' },
    { id: 'quantity', name: 'Fuel Quantity', align: 'center' },
    {
      id: 'action', disable: true, name: 'Action', align: 'center'
    }
  ],
  external: [
    {
      id: 'serial_number',
      name: 'S.No.',
      align: 'center',
      disable: true,
      sx: { minWidth: '64px !important', width: '64px !important', px: 0.75 }
    },
    { id: 'id', name: 'ID', align: 'center' },
    { id: 'date_time', name: 'Date Time', align: 'center' },
    { id: 'site_name', name: 'Site Name', align: 'left' },
    { id: 'dispenser_name', name: 'Dispenser', align: 'center' },
    { id: 'vehicle_number', name: 'Vehicle Number', align: 'center' },
    { id: 'odometer_entry', name: 'Odometer', align: 'center' },
    { id: 'quantity', name: 'Quantity', align: 'center' },
    { id: 'unit_price', name: 'Unit Price', align: 'center' },
    { id: 'amount', name: 'Amount', align: 'center' },
    {
      id: 'action', disable: true, name: 'Action', align: 'center'
    }
  ]
};

export const getAlignByColumnId = (headCells = []) => headCells.reduce((acc, cell) => {
  if (!cell?.id) return acc;
  const align = ['left', 'center', 'right'].includes(cell?.align) ? cell.align : 'left';
  acc[cell.id] = align;
  return acc;
}, {});

export const siteTableHeaders = [
  {
    id: 'serial_no', name: 'S.NO.', disable: true, align: 'center'
  },
  { id: 'code', name: 'Site Code', align: 'center' },
  { id: 'name', name: 'Site Name', align: 'center' },
  { id: 'city', name: 'Location', align: 'center' },
  { id: 'timezone', name: 'Timezone', align: 'center' },
  { id: 'dispensers_count', name: 'Total Dispensers', align: 'center' },
  { id: 'tanks_count', name: 'Total Tanks', align: 'center' },
  { id: 'vehicle_count', name: 'Total Vehicles', align: 'center' },
  { id: 'operators_count', name: 'Total Operators', align: 'center' },
  { id: 'active', name: 'Status', align: 'center' },
  {
    id: 'action', disable: true, name: 'Action', align: 'center'
  }
];

export const groupTableHeaders = [
  { id: 'id', name: 'ID', align: 'center' },
  { id: 'name', name: 'Name', align: 'center' },
  {
    id: 'type', name: 'Type', disable: true, align: 'center'
  },
  { id: 'created_at', name: 'Created On', align: 'center' },
  {
    id: 'action', disable: true, name: 'Action', align: 'center'
  }
];

export const tankTableHeaders = [
  { id: 'name', name: 'Tank Name', align: 'left' },
  { id: 'type', name: 'Tank Type', align: 'left' },
  { id: 'dispenser_name', name: 'Dispenser Name', align: 'center' },
  { id: 'current_balance', name: 'Current Volume', align: 'center' },
  { id: 'balance', name: 'Fuel Level', align: 'center' },
  { id: 'automation', name: 'Automaton', align: 'center' },
  {
    id: 'action', disable: true, name: 'Action', align: 'center'
  }
];

export const dispenserTableHeaders = [
  { id: 'station_name', name: 'Dispenser Name', align: 'left' },
  { id: 'address', name: 'Dispenser Address', align: 'center' },
  { id: 'site_name', name: 'Site Name', align: 'left' },
  { id: 'tank_name', name: 'Tank Name', align: 'left' },
  { id: 'mode', name: 'Dispenser Mode', align: 'center' },
  { id: 'article', name: 'Fuel Type', align: 'center' },
  { id: 'status', name: 'Status', align: 'center' },
  {
    id: 'action', disable: true, name: 'Action', align: 'center'
  }
];

export const cardTableHeaders = [
  { id: 'id', name: 'SL No', align: 'center' },
  { id: 'uid', name: 'Card UID', align: 'center' },
  { id: 'vehicle_number', name: 'Vehicle Number', align: 'center' },
  { id: 'site', name: 'Site', align: 'center' },
  { id: 'card_category', name: 'Card Category', align: 'center' },
  { id: 'per_filling_limit', name: 'Per Filling Limit', align: 'center' },
  { id: 'per_day_limit', name: 'Per Day Limit', align: 'center' },
  { id: 'limit_quantity', name: 'Limit Quantity', align: 'center' },
  { id: 'fill_limit_type', name: 'Fill Limit Type', align: 'center' },
  { id: 'active', name: 'Status', align: 'center' },
  {
    id: 'action', disable: true, name: 'Action', align: 'center'
  }
];

export const vehicleTableHeaders = [
  { id: 'registration_num', name: 'Registration Number', align: 'center' },
  { id: 'model', name: 'Vehicle Model', align: 'center' },
  { id: 'vehicle_group', name: 'Vehicle Group', align: 'center' },
  { id: 'site_name', name: 'Site name', align: 'center' },
  { id: 'asset_code', name: 'Asset code', align: 'center' },
  {
    id: 'type', name: 'Mileage', disable: true, align: 'center'
  },
  { id: 'active', name: 'Status', align: 'center' },
  {
    id: 'action', disable: true, name: 'Action', align: 'center'
  }
];

export const vehicleRecordTableHeaders = [
  { id: 'registration_num', name: 'Vehicle Number', align: 'center' },
  { id: 'shift', name: 'Shift', align: 'center' },
  { id: 'date', name: 'Date', align: 'center' },
  { id: 'opening_reading', name: 'Opening Reading', align: 'center' },
  { id: 'closing_reading', name: 'Closing Reading', align: 'center' },
  { id: 'running_hours', name: 'Running Hours', align: 'center' },
  { id: 'number_of_trips', name: 'Total Trips', align: 'center' },
  {
    id: 'quantity', disable: true, name: 'Quantity', align: 'center'
  },
  {
    id: 'hsd', disable: true, name: 'HSD', align: 'center'
  }
];

export const vehicleUtilizationTableHeaders = [
  { id: 'month', name: 'Month', align: 'center' },
  { id: 'registration_num', name: 'Vehicle Name', align: 'center' },
  { id: 'monthly_fixed_engine_hours', name: 'Fixed Engine Hours', align: 'center' },
  { id: 'total_worked_hour', name: 'Actual Running hours', align: 'center' },
  { id: 'total_filled', name: 'Filling', align: 'center' },
  { id: 'range', name: 'Utilisation', align: 'center' },
];

export const vehicleIgnitionTableHeaders = [
  { id: 'registration_num', name: 'Registration Number', align: 'center' },
  { id: 'status', name: 'Vehicle Status', align: 'center' },
];

export const userTableHeaders = [
  {
    id: 'first_name', name: 'User Name', align: 'center', width: '21%', minWidth: 200
  },
  {
    id: 'emp_id', name: 'Employee ID', align: 'center', width: '12%', minWidth: 120
  },
  {
    id: 'mobile_num', name: 'Phone', align: 'center', width: '14%', minWidth: 140
  },
  {
    id: 'city', name: 'Address', align: 'center', width: '23%', minWidth: 220
  },
  {
    id: 'timezone', name: 'Timezone', align: 'center', width: '12%', minWidth: 160
  },
  {
    id: 'is_active', name: 'Status', align: 'center', width: '10%', minWidth: 120
  },
  {
    id: 'action', disable: true, name: 'Action', align: 'center', width: '8%', minWidth: 90
  }
];

export const siteManagerTableHeaders = [
  ...userTableHeaders.slice(0, 3),
  {
    id: 'site_names', name: 'Sites', align: 'left', width: '18%', minWidth: 180
  },
  ...userTableHeaders.slice(3)
];

export const mileageReportTableHeaders = [
  { id: 'order_id', name: 'Order ID', align: 'center' },
  { id: 'start_time', name: 'Date', align: 'center' },
  { id: 'site_name', name: 'Site Name', align: 'left' },
  { id: 'group_name', name: 'Vehicle Group', align: 'left' },
  { id: 'registration_num', name: 'Vehicle No', align: 'center' },
  { id: 'uid', name: 'UID', align: 'center' },
  { id: 'fuel_type', name: 'Fuel Type', align: 'center' },
  { id: 'odometer_entry', name: 'Odometer entry', align: 'center' },
  { id: 'driven', name: 'Driven', align: 'center' },
  { id: 'quantity', name: 'Quantity', align: 'center' },
  { id: 'mileage', name: 'Mileage', align: 'center' }
];

export const reconciliationReportTableHeaders = [
  { id: 'id', name: 'Order ID', align: 'center' },
  { id: 'station_name', name: 'Dispenser Name', align: 'center' },
  { id: 'site_name', name: 'Site Name', align: 'center' },
  { id: 'date', name: 'Date', align: 'center' },
  { id: 'opening_value', name: 'Opening Stock', align: 'center' },
  { id: 'inward', name: 'Inward', align: 'center' },
  { id: 'transfer', name: 'Transfer', align: 'center' },
  { id: 'sales', name: 'Issued', align: 'center' },
  { id: 'stock', name: 'Closing Stock', align: 'center' },
];

export const cardApprovalTableHeaders = [
  { id: 'id', name: 'SL No', align: 'center' },
  { id: 'card_uid', name: 'Card Number', align: 'center' },
  { id: 'vehicle_registration_number', name: 'Vehicle Number', align: 'center' },
  { id: 'requested_quantity', name: 'Requested Limit', align: 'center' },
  { id: 'requested_on', name: 'Requested Date', align: 'center' },
  { id: 'approved_quantity', name: 'Approved Limit', align: 'center' },
  { id: 'approved_or_rejected_on', name: 'Approved Date', align: 'center' },
  { id: 'filled_quantity', name: 'Filled Limit', align: 'center' },
  { id: 'filled_on', name: 'Filled Date', align: 'center' },
  { id: 'remarks', name: 'Remarks', align: 'center' },
  { id: 'status', name: 'Status', align: 'center' },
  {
    id: 'action', disable: true, name: 'Action', align: 'center'
  },
];

export const vehicleBreakDownTableHeaders = [
  {
    id: 'id', name: 'SL No', align: 'center', sx: { width: 80, minWidth: 80 }
  },
  {
    id: 'vehicle_number', name: 'Vehicle Number', align: 'center', sx: { minWidth: 170 }
  },
  {
    id: 'type', name: 'Breakdown Type', align: 'center', sx: { minWidth: 150 }
  },
  {
    id: 'location', name: 'Breakdown Location', align: 'center', sx: { minWidth: 180 }
  },
  {
    id: 'start_time', name: 'Created On', align: 'center', sx: { minWidth: 190 }
  },
  {
    id: 'expense', name: 'Repair Cost', align: 'center', sx: { minWidth: 120 }
  },
  {
    id: 'duration', name: 'Breakdown Duration', align: 'center', sx: { minWidth: 150 }
  },
  {
    id: 'description', name: 'Description', disable: true, align: 'center', sx: { minWidth: 200 }
  },
  {
    id: 'remarks', name: 'Remarks', disable: true, align: 'center', sx: { minWidth: 200 }
  },
  {
    id: 'status', name: 'Status', align: 'center', sx: { minWidth: 130 }
  },
  {
    id: 'action',
    disable: true,
    name: 'Action',
    align: 'center',
    sx: {
      width: 120,
      minWidth: 120,
      position: 'sticky',
      right: 0,
      zIndex: 3,
      backgroundColor: '#FFFFFF',
      borderLeft: '1px solid #CBD5E1',
      boxShadow: '-1px 0 0 rgba(0, 0, 0, 0.12)',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: -9,
        width: 9,
        pointerEvents: 'none',
        background: 'linear-gradient(90deg, rgba(15, 23, 42, 0), rgba(15, 23, 42, 0.12))'
      }
    }
  }
];

export const sensorTransactionsTableHeaders = [
  { id: 'id', name: 'Order ID', align: 'center' },
  { id: 'vehicle_reg_num', name: 'Vehicle Number', align: 'center' },
  { id: 'filled_time', name: 'Filled Time', align: 'center' },
  { id: 'location', name: 'Location', align: 'left' },
  { id: 'quantity', name: 'Fuel Quantity', align: 'center' },
];

export const vehicleWiseFuelConsumptionTableHeaders = [
  { id: 'si_no', name: 'Sl. No', align: 'center' },
  { id: 'date', name: 'Date', align: 'center' },
  { id: 'contractor_name', name: 'Contractor Name', align: 'left' },
  { id: 'po_number', name: 'PO Number', align: 'center' },
  { id: 'department', name: 'Department', align: 'left' },
  { id: 'vehicle_type', name: 'Type of Vehicle', align: 'left' },
  { id: 'quantity', name: 'Quantity', align: 'center' },
  { id: 'site', name: 'Site', align: 'left' },
  { id: 'hr_or_odometer_reading', name: 'Hr / Odometer Reading', align: 'center' },
  { id: 'totaliser_reading', name: 'Totaliser Reading', align: 'center' }
];

export const tyreDataTableHeaders = [
  { id: 'tyre_number', name: 'Tyre Number', align: 'center' },
  { id: 'km_travelled', name: 'KM Travelled', align: 'center' },
  { id: 'vehicle_number', name: 'Vehicle Number', align: 'center' },
  { id: 'figment_date', name: 'Figment Date', align: 'center' },
  { id: 'expired', name: 'Active', align: 'center' },
  {
    id: 'action', disable: true, name: 'Action', align: 'center'
  }
];
